export const FALLBACK_CENTERS = [
  'Ferty9 Fertility Center - Banjara Hills',
  'Ferty9 Fertility Center - Karimnagar',
  'Ferty9 Fertility Center - KPHB',
  'Ferty9 Fertility Center - Kurnool',
  'Ferty9 Fertility Center - LB NAGAR',
  'Ferty9 Fertility Center - Maredpaly',
  'Ferty9 Fertility Center - Rajahmundry',
  'Ferty9 Fertility Center - Tirupati',
  'Ferty9 Fertility Center - Vijayawada',
  'Ferty9 Fertility Center - Vizag',
  'Ferty9 Fertility Center - Warngal',
] as const;

export const EXCLUDED_CENTER_NAMES = ['Super Admin', 'Management', 'All', ''] as const;
